import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import SubmissionLabel from '../SubmissionLabel/SubmissionLabel';
import BonusPointsCheckbox from '../BonusPointsCheckbox/BonusPointsCheckbox';
import SubmissionAction from '../SubmissionAction/SubmissionAction';
import BillContent from '../BillContent/BillContent';
import { OrderParams, PreparedCalculateData } from '../../../models/Calculate';
import { useServicePaymentActions } from '../../../hooks/useServicePaymentActions';
import { TransformServicePreset } from '../../../models/ServicePresets';
import { AccountTypes, QueryParams } from '../../../models/Common';
import { IPermission } from '../../../models/UserInfo';
import { InfoBlockType } from '../../../pages/Payment/PaymentRefactor';
import { ApiError } from '../../../models/ApiError';
import { getSearchParamValue } from '../../../utils';

interface ServicePaymentFormRefactor {
  calculation: PreparedCalculateData | null;
  isLoading: boolean;
  onChangeUseBonusPoints: (e: boolean) => void;
  isShowBonusCheckbox: boolean;
  isPaidServiceSuspension?: boolean;
  maxCountMoth?: number;
  params: OrderParams;
  init: TransformServicePreset | undefined;
  accountType: AccountTypes | '';
  typeInfoBlock: InfoBlockType;
  Permissions: IPermission | undefined;
  calculateError: ApiError;
}

const ServicePaymentFormRefactor: FC<ServicePaymentFormRefactor> = ({
  calculation,
  isLoading,
  onChangeUseBonusPoints,
  isPaidServiceSuspension,
  maxCountMoth,
  isShowBonusCheckbox,
  params,
  init,
  accountType,
  typeInfoBlock,
  Permissions,
  calculateError,
}) => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const promoBannerId = +getSearchParamValue(QueryParams.BannerId, search);
  const { handleActivate, handlePay, handleRestore, isLoadingActivate } = useServicePaymentActions({
    params,
    calculation,
    init,
    accountType,
    promoBannerId,
  });
  const isSuspensionReachedLimit = isPaidServiceSuspension && !maxCountMoth;
  return (
    <div className="payment__content__submission">
      <div className="card card__secondary">
        <SubmissionLabel
          calculation={calculation}
          isLoaded={!isLoadingActivate && !isLoading && !!calculation && !calculateError}
          isPaidServiceSuspension={!!isPaidServiceSuspension}
          isShowPeriod={typeInfoBlock !== 'hasPrepaid' && typeInfoBlock !== 'notPrepaid' && !isSuspensionReachedLimit}
        />
        {isShowBonusCheckbox && !isSuspensionReachedLimit && !calculateError && calculation && calculation.bonus > 0 ? (
          <BonusPointsCheckbox onChange={onChangeUseBonusPoints} />
        ) : null}
        <SubmissionAction
          isDisabled={init?.IsDisabled}
          handleAction={calculation?.pay_amount ? handlePay : handleActivate}
          label={calculation?.pay_amount ? t('buttons.pay') : t('buttons.activate')}
          handleRestore={handleRestore}
          isLoading={isLoadingActivate || isLoading || calculateError}
          isDisabledActivate={
            !Permissions?.Services.Activate ||
            isSuspensionReachedLimit ||
            typeInfoBlock === 'hasPrepaid' ||
            typeInfoBlock === 'notPrepaid' ||
            !calculation
          }
        />

        {Permissions?.Services.Activate &&
        !calculateError &&
        !isSuspensionReachedLimit &&
        typeInfoBlock !== 'hasPrepaid' &&
        typeInfoBlock !== 'notPrepaid' &&
        calculation ? (
          <BillContent
            calculation={calculation}
            userBalance={(calculation && calculation.balance) || 0}
            userBonuses={(calculation && calculation.bonus) || 0}
            billDiscountPercent={(calculation && calculation.view.dsc_percent) || 0}
            serviceName={calculation.view.name}
            isShowEarnBonuses={!!calculation && !!Permissions?.Info?.ShowBonuses && calculation.earn_bonus_amount > 0}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ServicePaymentFormRefactor;
